import React from 'react';
import { useTranslation } from 'react-i18next';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import LoadingContainer from '../../../shared/ui/loading-container/loading-container.jsx';
import PageHeader from '../../../shared/ui/page-header/page-header.jsx';

function SystemEmailSettingsPageView({
  form,
  isLoading,
  isSaving,
  error,
  success,
  formErrors,
  hasChanges,
  onFormChange,
  resetForm,
  saveForm,
}) {
  const { t } = useTranslation();
  return (
    <div>
      <FloatingAlerts
        info={isSaving ? t('emailSettings.savingInfo') : ''}
        error={error}
        success={success}
      />
      <PageHeader title={t('emailSettings.title')} subtitle={t('emailSettings.subtitle')} />

      <div className="widget-content searchable-container list">
        <div className="card card-body">
          <LoadingContainer isLoading={isLoading} hasData className="">
            <form onSubmit={saveForm}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">{t('emailSettings.fromAddressLabel')}</label>
                  <input
                    type="email"
                    className={`form-control ${formErrors.fromAddress ? 'is-invalid' : ''}`}
                    value={form.fromAddress}
                    onChange={(event) => onFormChange('fromAddress', event.target.value)}
                    disabled={isSaving}
                    required
                  />
                  {formErrors.fromAddress ? <div className="invalid-feedback">{formErrors.fromAddress}</div> : null}
                </div>
                <div className="col-md-6">
                  <label className="form-label">{t('emailSettings.fromNameLabel')}</label>
                  <input
                    type="text"
                    className={`form-control ${formErrors.fromName ? 'is-invalid' : ''}`}
                    value={form.fromName}
                    onChange={(event) => onFormChange('fromName', event.target.value)}
                    disabled={isSaving}
                  />
                  {formErrors.fromName ? <div className="invalid-feedback">{formErrors.fromName}</div> : null}
                </div>
                <div className="col-md-6">
                  <label className="form-label">{t('emailSettings.smtpHostLabel')}</label>
                  <input
                    type="text"
                    className={`form-control ${formErrors.host ? 'is-invalid' : ''}`}
                    value={form.host}
                    onChange={(event) => onFormChange('host', event.target.value)}
                    disabled={isSaving}
                    required
                  />
                  {formErrors.host ? <div className="invalid-feedback">{formErrors.host}</div> : null}
                </div>
                <div className="col-md-6">
                  <label className="form-label">{t('emailSettings.smtpPortLabel')}</label>
                  <input
                    type="number"
                    min="1"
                    step="1"
                    className={`form-control ${formErrors.port ? 'is-invalid' : ''}`}
                    value={form.port}
                    onChange={(event) => onFormChange('port', event.target.value)}
                    disabled={isSaving}
                    required
                  />
                  {formErrors.port ? <div className="invalid-feedback">{formErrors.port}</div> : null}
                </div>
                <div className="col-md-6">
                  <label className="form-label">{t('emailSettings.usernameLabel')}</label>
                  <input
                    type="text"
                    className={`form-control ${formErrors.username ? 'is-invalid' : ''}`}
                    value={form.username}
                    onChange={(event) => onFormChange('username', event.target.value)}
                    disabled={isSaving}
                    required
                  />
                  {formErrors.username ? <div className="invalid-feedback">{formErrors.username}</div> : null}
                </div>
                <div className="col-md-6">
                  <label className="form-label">{t('emailSettings.passwordLabel')}</label>
                  <input
                    type="password"
                    className={`form-control ${formErrors.password ? 'is-invalid' : ''}`}
                    value={form.password}
                    onChange={(event) => onFormChange('password', event.target.value)}
                    disabled={isSaving}
                    required
                  />
                  {formErrors.password ? <div className="invalid-feedback">{formErrors.password}</div> : null}
                </div>
              </div>

              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={resetForm}
                  disabled={isSaving || !hasChanges}
                >
                  {t('emailSettings.reset')}
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isLoading || isSaving || !hasChanges}
                >
                  {t('emailSettings.saveChanges')}
                </button>
              </div>
            </form>
          </LoadingContainer>
        </div>
      </div>
    </div>
  );
}

export default SystemEmailSettingsPageView;
